// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"SGSPageLoader_loaderContainer__201-2","loaderCard":"SGSPageLoader_loaderCard__2Cc4a"};